import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Sweep colour (rgba), default semi-transparent white */
  color?: string;
  /** Full sweep cycle duration seconds, default 3.5 */
  dur?: number;
  /** Direction of travel, default "ltr" */
  direction?: "ltr" | "rtl";
}

/**
 * ColorSweep — hard-edge colour wipe that passes across the banner.
 * Good for paint / wall / surface-refresh themed banners.
 */
const ColorSweep: React.FC<Props> = ({
  color = "rgba(255,255,255,0.5)",
  dur = 3.5,
  direction = "ltr",
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-colorsweep {
        0%   { transform: translateX(${direction === "ltr" ? "-105%" : "105%"}); }
        55%  { transform: translateX(0%); }
        100% { transform: translateX(${direction === "ltr" ? "105%" : "-105%"}); }
      }
    `}</style>
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(90deg, transparent, ${color} 45%, ${color} 55%, transparent)`,
        animation: `oot-colorsweep ${dur}s ease-in-out infinite`,
        mixBlendMode: "overlay",
      }}
    />
  </div>
);

export default ColorSweep;
